"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { signinWithCredential } from "../_actions";
import { LoaderIcon } from "lucide-react";
import { useActionState } from "react";
import InputError from "@/components/input-error";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
export default function SigninForm() {
  const $ = _c(21);
  const [state, action, loading] = useActionState(signinWithCredential, undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Label htmlFor="email" className="block text-sm">Email</Label>;
    t1 = <Input type="email" required={true} name="email" id="email" placeholder="Email" className="w-full" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = state?.errors?.email;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="space-y-2">{t0}{t1}<InputError error={t2} /></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label htmlFor="password" className="text-title text-sm">Password</Label>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center justify-between">{t4}<Button asChild={true} variant="link" size="sm"><Link href="/auth/password-reset" className="link intent-info variant-ghost text-sm">Forgot your Password ?</Link></Button></div>;
    t6 = <Input type="password" required={true} name="password" id="password" className="input sz-md variant-mixed w-full" placeholder="Password" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  const t7 = state?.errors?.password;
  let t8;
  if ($[7] !== t7) {
    t8 = <div className="space-y-0.5">{t5}{t6}<InputError error={t7} /></div>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = state?.errors?.root;
  let t10;
  if ($[9] !== t9) {
    t10 = <InputError error={t9} />;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== loading) {
    t11 = loading && <LoaderIcon className="animate-spin" />;
    $[11] = loading;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== loading || $[14] !== t11) {
    t12 = <Button className="w-full justify-center" type="submit" disabled={loading}>{t11}Sign In</Button>;
    $[13] = loading;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12 || $[18] !== t3 || $[19] !== t8) {
    t13 = <form action={action} className="space-y-6">{t3}{t8}{t10}{t12}</form>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t3;
    $[19] = t8;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}